module.exports = "/packs/homebase_popup_bg-sp-669797829d38599325a2b3298023607d.png";